import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import i18n from "src/locales";
import { errorConstants } from "src/utils/services/PurchaseErrorMessages";
import { AppDispatch } from "../internal";

export type EnrollmentErrors = {
  name?: boolean | string;
  email?: boolean | string;
  password?: boolean | string;
  confirmPassword?: boolean | string;
  phoneNumber?: boolean | string;
  termAgreement?: boolean | string;
};

export interface PaymentEnrollmentFormState {
  hasErrors: boolean;
  enrollmentErrors: EnrollmentErrors;
  enrollmentInfo: {
    name: string;
    email: string;
    password: string;
    confirmPassword: string;
    phoneNumber: string;
    phoneNumberCountryCode: string;
    termAgreement: boolean;
  };
}

const initialState: PaymentEnrollmentFormState = {
  enrollmentErrors: {},
  enrollmentInfo: {
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    phoneNumber: "",
    phoneNumberCountryCode: "",
    termAgreement: false,
  },
  hasErrors: true,
};

const paymentEnrollmentFormSlice = createSlice({
  name: "paymentEnrollmentForm",
  initialState,
  reducers: {
    updatePaymentEnrollmentFormState(
      state,
      action: PayloadAction<
        Partial<Omit<PaymentEnrollmentFormState, "hasErrors">>
      >
    ) {
      const newState = { ...state, ...action.payload };
      const hasErrors = Object.keys(newState.enrollmentErrors).some(
        (key) => newState.enrollmentErrors[key]
      );
      newState.hasErrors = hasErrors;
      return newState;
    },
    setError(state, action: PayloadAction<EnrollmentErrors>) {
      return {
        ...state,
        enrollmentErrors: { ...state.enrollmentErrors, ...action.payload },
      };
    },
  },
});

export const { updatePaymentEnrollmentFormState } =
  paymentEnrollmentFormSlice.actions;

const { setError } = paymentEnrollmentFormSlice.actions;

export function applyEnrollmentError(error: errorConstants) {
  return (dispatch: AppDispatch) => {
    const errorMap = {
      [errorConstants.errorActiveSubscription]: {
        email: i18n.t(
          "enrollmentForm:inputFields:email:errorMessages:activeSubscription"
        ),
      },
      [errorConstants.errorInvalidEmail]: {
        email: i18n.t("enrollmentForm:inputFields:email:errorMessages:invalid"),
      },
      [errorConstants.errorTermAgreement]: {
        termAgreement: i18n.t("payment:terms:error"),
      },
    };

    const errorState = errorMap[error];
    if (errorState) {
      dispatch(setError(errorState));
      return true;
    }

    return false;
  };
}

export default paymentEnrollmentFormSlice;
